<p-menubar
  [model]="isWorkshopMode ? [] : menuBarItems"
  [autoDisplay]="false"
  [styleClass]="getMenuBarClasses()">
  <ng-template pTemplate="start">
    <div class="flex gap-2 align-items-center">
      <!-- The commune logo (or the atlas logo as fallback) doubles as home button -->
      <button
        pButton
        type="button"
        class="atlas-home-button surface-0 border-round-xl overflow-hidden p-0"
        [text]="true"
        (click)="goToLandingpage()"
        pTooltip="Zur Startseite"
        tooltipPosition="bottom"
        aria-label="Zur Startseite">
        <app-logo
          hStyleClass="h-2rem md:h-3rem max-w-7rem"
          [autoWidth]="true"
          [logoFileName]="activeCommune?.atlasConfig?.logo" />
      </button>
      @if (isWorkshopMode) {
        <button
          pButton
          (click)="templatePanel.toggle($event)"
          [rounded]="true"
          [outlined]="true"
          pTooltip="Vorlagen"
          icon="fas fa-shapes"></button>

        <span
          class="flex align-items-center gap-2 text-color-secondary text-sm font-medium px-2">
          <i class="fas fa-screwdriver-wrench"></i>
          {{ isGridEmpty ? 'Werkstatt - wähle eine Vorlage' : 'Werkstatt' }}
        </span>
        <p-overlayPanel
          #templatePanel
          [showCloseIcon]="true"
          [style]="{ width: getTopicFlyoutWidth() }"
          styleClass="topic-flyout-panel border-round-2xl mr-8">
          <div class="flex flex-column gap-3 p-1">
            <app-header icon="fas fa-shapes" text="Vorlagen"></app-header>
            @if (!isGridEmpty) {
              <div
                class="flex align-items-center gap-2 text-color-secondary text-sm px-1">
                <i class="fas fa-triangle-exclamation"></i>
                Eine Vorlage ersetzt die aktuelle Ansicht.
              </div>
            }
            <p-divider styleClass="my-0"></p-divider>
            <div class="grid overflow-y-auto -mt-2" style="max-height: 36rem">
              @for (template of templateService.templates; track template.key) {
                <div class="col-12 sm:col-6 lg:col-4">
                  <div
                    class="topic-flyout-section h-full p-3 border-round-xl flex flex-column gap-2 cursor-pointer"
                    (click)="selectTemplate(template.key, templatePanel)">
                    <div class="flex align-items-center gap-3">
                      <span
                        class="bg-primary flex align-items-center justify-content-center text-white border-circle w-3rem h-3rem flex-shrink-0 shadow-2">
                        <i [class]="template.icon"></i>
                      </span>
                      <span class="font-bold text-lg">{{
                        template.label
                      }}</span>
                    </div>
                    <div class="text-color-secondary">
                      {{ template.description }}
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </p-overlayPanel>
      }
      @if (!isWorkshopMode && topicSections.length > 0) {
        <button
          pButton
          (click)="topicPanel.toggle($event)"
          [rounded]="true"
          pTooltip="Themen & Themenbereiche"
          [class]="getTopicButtonClasses()"
          [icon]="
            globalStore.activeTopic()
              ? 'fas fa-' + globalStore.activeTopic()!.icon
              : 'fas fa-compass'
          "></button>

        <p-overlayPanel
          #topicPanel
          [showCloseIcon]="true"
          [style]="{ width: getTopicFlyoutWidth() }"
          styleClass="topic-flyout-panel border-round-2xl mr-8">
          <div class="flex flex-column gap-3 p-1">
            <app-header
              icon="fas fa-compass"
              text="Themen &amp; Themenbereiche!"></app-header>
            <p-divider styleClass="my-0"></p-divider>
            <div
              class="topic-flyout-grid overflow-y-auto"
              [style.columns]="topicSections.length > 1 ? '18rem' : 1">
              @for (section of topicSections; track section.topic._id) {
                <div
                  class="topic-flyout-section p-3 border-round-xl flex flex-column gap-2">
                  <div
                    class="flex align-items-center gap-3 cursor-pointer"
                    (click)="selectTopic(section.topic, topicPanel)">
                    <span
                      class="flex align-items-center justify-content-center text-white border-circle w-3rem h-3rem flex-shrink-0 shadow-2"
                      [ngClass]="getSectionBadgeClasses(section.topic)">
                      <i [class]="'fas fa-' + section.topic.icon"></i>
                    </span>
                    <span class="font-bold text-lg">{{
                      section.topic.title
                    }}</span>
                  </div>
                  <ul
                    class="topic-flyout-list list-none p-0 m-0"
                    [style.columns]="getTopicListColumns()">
                    @for (
                      category of getVisibleCategories(section);
                      track category._id
                    ) {
                      <li>
                        <a
                          class="topic-flyout-item flex align-items-baseline justify-content-between gap-2 p-2 border-round-lg text-color no-underline cursor-pointer"
                          (click)="
                            selectCategory(section.topic, category, topicPanel)
                          ">
                          <span class="flex align-items-baseline gap-2">
                            <i
                              class="fas fa-layer-group text-color-secondary"></i>
                            {{ category.title }}
                          </span>
                          <i
                            class="fas fa-chevron-right text-xs text-color-secondary"></i>
                        </a>
                      </li>
                    }
                  </ul>
                  @if (
                    getHiddenCategoryCount(section) > 0 ||
                    isTopicExpanded(section.topic)
                  ) {
                    <a
                      class="topic-flyout-toggle flex align-items-baseline gap-2 px-2 text-sm text-primary font-medium no-underline cursor-pointer"
                      role="button"
                      tabindex="0"
                      (click)="toggleTopicExpanded(section.topic)"
                      (keydown.enter)="toggleTopicExpanded(section.topic)">
                      @if (isTopicExpanded(section.topic)) {
                        <i class="fas fa-chevron-up text-xs"></i>
                        weniger anzeigen
                      } @else {
                        <i class="fas fa-chevron-down text-xs"></i>
                        {{ getHiddenCategoryCount(section) }} weitere anzeigen
                      }
                    </a>
                  }
                </div>
              }
            </div>
          </div>
        </p-overlayPanel>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="item" let-item>
    <a
      class="flex align-items-center p-menuitem-link gap-2 py-2 px-2 mr-1 border-round-xl transition-colors transition-duration-200"
      [routerLink]="item.routerLink || null"
      [routerLinkActive]="'p-menuitem-link-active font-bold'"
      [pTooltip]="item.pTooltip">
      @if (item.icon) {
        <span [class]="item.icon" class="text-lg"></span>
      }
      <span class="p-menuitem-text font-medium text-sm">{{ item.label }}</span>
      @if (item.items && item.items.length > 0) {
        <i class="fas fa-chevron-down text-xs ml-1 opacity-50"></i>
      }
    </a>
  </ng-template>

  <ng-template pTemplate="end">
    <div class="justify-content-end flex flex-1 align-items-center gap-2">
      <app-atlas-search></app-atlas-search>
      @if (
        activeUserStore.context() !== 'atlasExternal' &&
        activeUserStore.canAccessEntityAdder()
      ) {
        @for (item of topItems; track $index) {
          <p-splitButton
            class="sm:flex hidden"
            [rounded]="true"
            [raised]="true"
            [text]="true"
            size="small"
            styleClass="surface-0"
            [icon]="item.icon"
            (onClick)="quickSave()"
            [model]="item.items">
            <ng-template pTemplate="dropdownicon">
              <i class="fas fa-chevron-down"></i>
            </ng-template>
          </p-splitButton>
        }
      }

      <app-theme-switcher></app-theme-switcher>

      <app-active-user-avatar
        size="large"
        [icon]="
          activeUserStore.context() === 'atlasExternal'
            ? 'fas fa-earth-europe'
            : 'fas fa-house-user'
        "
        [addBookmarks]="true"
        [extraItems]="miscItems"
        [styleClass]="'bg-primary'"></app-active-user-avatar>
    </div>
  </ng-template>
</p-menubar>
<p-overlayPanel
  #morePanel
  [showCloseIcon]="true"
  styleClass="topic-flyout-panel more-flyout-panel border-round-2xl mr-8">
  <div class="flex flex-column gap-3 p-1">
    <app-header
      icon="fas fa-ellipsis"
      text="Weitere Themenbereiche"></app-header>
    <p-divider styleClass="my-0"></p-divider>
    <div class="flex gap-3 -mt-1">
      <!-- master: the overflowing "Themenbereiche" -->
      <ul
        class="more-flyout-categories list-none p-0 m-0 flex flex-column gap-1 flex-shrink-0 overflow-y-auto">
        @for (
          section of overflowSections;
          track section.category._id;
          let i = $index
        ) {
          <li>
            <a
              class="topic-flyout-item flex align-items-baseline gap-2 p-2 border-round-lg text-color no-underline cursor-pointer"
              [class.more-flyout-category-active]="i === selectedOverflowIndex"
              (mouseenter)="selectedOverflowIndex = i"
              (click)="selectedOverflowIndex = i">
              <i
                class="text-color-secondary"
                [class]="
                  section.category.private
                    ? 'fas fa-eye-slash'
                    : 'fas fa-layer-group'
                "></i>
              <span class="flex-1">{{ section.category.title }}</span>
              <span class="text-xs text-color-secondary">{{
                section.items.length
              }}</span>
              <i class="fas fa-chevron-right text-xs text-color-secondary"></i>
            </a>
          </li>
        }
      </ul>

      <!-- detail: the views/stories of the selected "Themenbereich" -->
      @if (overflowSections[selectedOverflowIndex]; as section) {
        <div
          class="more-flyout-detail flex-1 min-w-0 p-3 border-round-xl flex flex-column gap-2">
          <span class="font-bold text-lg">{{ section.category.title }}</span>
          <ul class="more-flyout-items list-none p-0 m-0 overflow-y-auto">
            @for (item of section.items; track $index) {
              <li>
                <a
                  class="topic-flyout-item flex align-items-baseline gap-2 p-2 border-round-lg text-color no-underline cursor-pointer"
                  [routerLink]="item.routerLink || null"
                  routerLinkActive="font-bold text-primary"
                  (click)="selectOverflowItem(item, $event)">
                  <i [class]="item.icon" class="text-color-secondary"></i>
                  {{ item.label }}
                </a>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
</p-overlayPanel>
<p-confirmDialog key="overwriteBookmark" #cd>
  <ng-template pTemplate="headless" let-message>
    <div class="p-card border-round pt-1 p-4">
      <app-header
        icon="fas fa-floppy-disk"
        [text]="message.header"></app-header>

      <div class="flex">
        Ihre Ansicht wird mit der aktuellen Ansicht überschrieben.
      </div>

      <div class="flex align-items-center gap-3 mt-4">
        <button
          [rounded]="true"
          [outlined]="true"
          severity="secondary"
          pButton
          icon="fas fa-times"
          label="nein, abbrechen"
          (click)="cd.reject()"></button>
        <button
          [rounded]="true"
          pButton
          icon="fas fa-check"
          label="ja, fortfahren"
          (click)="cd.accept()"
          class="ml-auto"></button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<p-dialog
  [modal]="true"
  [(visible)]="infoVisible"
  [style]="{ width: '60rem' }"
  [breakpoints]="{ '960px': '95vw' }"
  [dismissableMask]="true"
  [focusOnShow]="false">
  <ng-template pTemplate="header">
    <app-header
      icon="fas fa-info-circle"
      [text]="'Willkommen im Kommunal-Atlas!'"
      styleClass="m-0"></app-header>
  </ng-template>

  <div class="info-overlay">
    <section class="info-overlay__intro">
      <span class="info-overlay__eyebrow">Die wichtigsten Funktionen</span>
      <h2>Kommunale Daten interaktiv, übersichtlich und individuell</h2>
      <p>
        Kleinräumige Analysen, Zeitvergleiche und verschiedene
        Darstellungsformen helfen Ihnen dabei, Entwicklungen und Zusammenhänge
        schnell zu erkennen.
      </p>
    </section>

    <h3 class="info-overlay__section-title">
      <i class="fas fa-compass"></i> Orientierung
    </h3>
    <div class="info-overlay__modes">
      <article class="mode">
        <span class="mode__icon mode__icon--plain">
          <i class="fas fa-house"></i>
        </span>
        <div>
          <h4>Zurück zur Startseite</h4>
          <p>Ein Klick auf das Logo oben links bringt Sie jederzeit zurück.</p>
        </div>
      </article>
      <article class="mode">
        <span class="mode__icon mode__icon--plain">
          <i class="fas fa-location-dot"></i>
        </span>
        <div>
          <h4>Wo bin ich gerade?</h4>
          <p>
            Neben dem Logo sehen Sie das Symbol des aktuellen Themas (sofern
            angelegt). Ein Klick darauf zeigt alle Themen und Themenbereiche.
          </p>
        </div>
      </article>
      <article class="mode">
        <span class="mode__icon mode__icon--plain">
          <i class="fas fa-bars"></i>
        </span>
        <div>
          <h4>Navigation oben</h4>
          <p>
            Die Dropdowns am oberen Rand führen zu Themenbereichen und in die
            Teilräume der Kommune (sofern angelegt).
          </p>
        </div>
      </article>
      <article class="mode">
        <span class="mode__icon mode__icon--plain">
          <i class="fas fa-search"></i>
        </span>
        <div>
          <h4>Gezielte Suche</h4>
          <p>
            Suchen Sie oben rechts nach Indikatoren, (Teil-)Räumen, Standorten,
            Ansichten, Berichten oder Themen.
          </p>
        </div>
      </article>
      <article class="mode">
        <span class="mode__icon mode__icon--plain">
          <i class="fas fa-calendar-days"></i>
        </span>
        <div>
          <h4>Jahres-Slider</h4>
          <p>
            Vergleichen Sie verschiedene Jahre und machen Sie Entwicklungen
            sichtbar (sofern aktiviert).
          </p>
        </div>
      </article>
      <article class="mode">
        <span class="mode__icon mode__icon--plain">
          <i class="fas fa-moon"></i>
        </span>
        <div>
          <h4>Nachtmodus</h4>
          <p>
            Über das Mond-Icon oben rechts schalten Sie auf eine augenschonende
            Darstellung um.
          </p>
        </div>
      </article>
    </div>

    <h3 class="info-overlay__section-title">
      <i class="fas fa-star"></i> Selbst gestalten
    </h3>
    <div class="info-overlay__features">
      <article class="feature feature--wide">
        <header class="feature__header">
          <h4>Erstellen</h4>
          <span class="feature__icon">
            <i class="fas fa-screwdriver-wrench"></i>
          </span>
        </header>
        <p>
          Über die Startseite (Logo oben links) erreichen Sie „Suche“ und
          „Erstellen“. Dort finden Sie alle Daten der Kommune, auch die noch
          nicht aufbereiteten, und gestalten ganz flexibel eigene Ansichten.
        </p>
        <ul class="feature__chips">
          @for (type of widgetTypes; track type) {
            <li>
              <i [class]="widgetTypeDisplay[type]?.icon"></i>
              {{ widgetTypeDisplay[type]?.label }}
            </li>
          }
        </ul>
      </article>

      <article class="feature">
        <header class="feature__header">
          <h4>Werkzeuge unten rechts</h4>
          <span class="feature__icon">
            <i class="fas fa-toolbox"></i>
          </span>
        </header>
        <ul class="feature__tips">
          <li>
            <span class="key"><i class="fas fa-clipboard-list"></i></span>
            Vergleichsberichte: Teilräume oder Standorte über alle Indikatoren
            gegenüberstellen
          </li>
          <li>
            <span class="key"><i class="fas fa-pen"></i></span>
            Aktuelle Ansicht bearbeiten, z. B. Diagrammgrößen ändern oder
            Diagramme hinzufügen
          </li>
          <li>
            <span class="key"><i class="fas fa-wrench"></i></span>
            Ansicht leeren und von vorne beginnen
          </li>
        </ul>
      </article>

      <article class="feature">
        <header class="feature__header">
          <h4>Im Bearbeitungs-Modus</h4>
          <span class="feature__icon feature__icon--plain">
            <i class="fas fa-pen-ruler"></i>
          </span>
        </header>
        <ul class="feature__tips">
          <li>
            <span class="key"><i class="fas fa-plus-circle"></i></span>
            Neue Darstellung hinzufügen
          </li>
          <li>
            <span class="key"><i class="fas fa-eye"></i></span>
            Zurück in den Lese-Modus wechseln
          </li>
        </ul>
      </article>
    </div>

    <footer class="info-overlay__outro">
      <i class="fas fa-rocket"></i>
      <p>
        <b>Viel Freude beim Erkunden, Vergleichen und Gestalten!</b>
      </p>
    </footer>
  </div>
</p-dialog>
